export const ENVIRONMENT_COMMON = {
  OBJECT_RESPONSE: "object",
  WHATSAPP: "whatsapp",
  STATUS: "status",
  FORCE_START: "force-start",
  FORCE_STOP: "force-stop",
  SALE: "sale",
  PARAMETER: "parameter",
  ACTION: "action",
  CLIENTS: 'clients',
  MESSAGE: "message",
  MARKETING: "marketing",
  MMARKETING_MESSAGE_ID: 1,
  LOGIN: "login",
  RESET_PASSWD: "reset-password",
  RENEW_PASSWD: "renew-password",
  TOKEN: 'token',
  ROLE: 'role',
  EXPIRES_IN: 'expiresIn',
  REPORT_CLIENT: 'report-client',
  SENT_MESSAGES: 'sent-messages',
  maxW768: '(max-width: 768px)',
  minW768: '(min-width: 768px)',
  minW1080: '(min-width: 1080px)',
  minW1420: '(min-width: 1420px)',
}
